import React from 'react';
import { useFrontload } from 'react-frontload';
import { apiV1 } from '../../lib/api';
import { WaterbodyBoatRampsPage } from './waterbody_boat_ramps_page';

interface WaterbodyBoatRampsPageContainerProps {
  urlSlug: string;
}

const WaterbodyBoatRampsPageContainer = (props: WaterbodyBoatRampsPageContainerProps) => {
  const { urlSlug } = props;

  const { data, frontloadMeta } = useFrontload(`WaterbodyBoatRampsPage:${urlSlug}`, async () => {
    try {
      const [waterbodyRes, boatLandingsRes] = await Promise.allSettled([
        apiV1.waterbodyFetch(urlSlug),
        apiV1.waterbodyBoatLandingsFetch(urlSlug),
      ]);

      return {
        boatLandings:
          boatLandingsRes.status === 'fulfilled' ? boatLandingsRes.value.data.data : null,
        waterbodyDetail: waterbodyRes.status === 'fulfilled' ? waterbodyRes.value.data.data : null,
      };
    } catch (e) {
      console.log(e);
    }
  });

  const boatLandings = data?.boatLandings || [];
  const waterbodyDetail = data?.waterbodyDetail;

  if (!frontloadMeta.done) {
    return null;
  }

  return <WaterbodyBoatRampsPage boatLandings={boatLandings} waterbodyDetail={waterbodyDetail} />;
};

export default WaterbodyBoatRampsPageContainer;
